import { TableFooter, TableRow, TableCell } from "@mui/material";
import useGrandTotal from "../../hooks/useGrandTotal";
import { NumberField, RecordContextProvider, TextField } from "react-admin";

const FactoryDebtCorrectionFooterList = () => {
  const { data, isLoading, error } = useGrandTotal();

  // if (error) return <Error />;

  return (
    <RecordContextProvider value={data ? data : {}}>
      <TableFooter>
        <TableRow
          sx={{
            "& td": {
              borderTop: "1px solid rgba(224, 224, 224, 1) !important",
            },
            "& .MuiTypography-root": {
              color: (theme) => theme.palette.primary.main,
              fontWeight: "bold",
            },
          }}
        >
          <TableCell />
          <TableCell />
          <TableCell colSpan={5}>
            <RecordContextProvider value={{ name: "GRAND TOTAL" }}>
              <TextField source="name" />
            </RecordContextProvider>
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            <NumberField source="value" textAlign="right" />
          </TableCell>
          <TableCell colSpan={3} />
        </TableRow>
      </TableFooter>
    </RecordContextProvider>
  );
};

export default FactoryDebtCorrectionFooterList;
